module.exports = __webpack_public_path__ + "img/patient-specific.aea58063.png";